// dashboard strings (ar).
// Machine-drafted — review with a native speaker before launch.
const dashboard = {
	dashboard: {
		title: 'لوحة التحكم',
		cards: 'البطاقات',
		searchCardPlaceholder: 'أدخل عنوان البطاقة',
		viewMore: 'عرض المزيد',
		createNewCard: 'إنشاء بطاقة جديدة',
		createNewCardDesc: 'يشجّعك CardClan على التواصل مع أحبائك ومشاركة المحبة معهم.',
		letsCreate: 'لننشئ',
		selectTemplate: 'اختر قالبًا',
		searchCategoryPlaceholder: 'أدخل اسم الفئة',
		seeLess: 'عرض أقل',
		moreCount: '+%{count} المزيد',
		notEnoughData: 'لا توجد بيانات كافية للعرض.',
		emailsOpenRate: 'معدل فتح الرسائل',
		cardsOpenRate: 'معدل فتح البطاقات',
		tour: {
			dashboardTitle: 'لوحة التحكم',
			dashboardDesc: 'مرحبًا بك في لوحة التحكم! يمكنك هنا رؤية نظرة عامة على أنشطتك.',
			createCardTitle: 'إنشاء بطاقة',
			createCardDesc: 'انقر هنا لإنشاء بطاقة جديدة من قالب.',
			searchCardsTitle: 'البحث عن البطاقات',
			searchCardsDesc: 'يمكنك البحث عن بطاقاتك الحالية هنا.',
		},
		stats: {
			cardsStatistics: 'إحصائيات البطاقات',
			graph: 'الرسم البياني',
			contactsEngagement: 'تفاعل جهات الاتصال',
			contactEngagement: 'تفاعل جهة الاتصال',
			emailsOpened: 'الرسائل المفتوحة',
			cardsOpened: 'البطاقات المفتوحة',
			conversionRate: 'معدل التحويل',
			totalReactions: 'إجمالي التفاعلات',
			totalComments: 'إجمالي التعليقات',
			totalDownloads: 'إجمالي التنزيلات',
			last7Days: 'آخر 7 أيام',
			last15Days: 'آخر 15 يومًا',
			last30Days: 'آخر 30 يومًا',
			last2Months: 'آخر شهرين',
			last6Months: 'آخر 6 أشهر',
			lastYear: 'العام الماضي',
			allCards: 'كل البطاقات',
		},
		swal: {
			cardAlreadyDeliveredTitle: 'تم تسليم البطاقة بالفعل',
			cardAlreadyDeliveredText: 'يمكنك استنساخ هذه البطاقة لجدولة بطاقة جديدة',
			workflowCardTitle: 'تُستخدم هذه البطاقة في سير عمل',
			workflowCardText: 'قد يؤدي تعديل علامات الدمج أو المحتوى إلى تعطيل سير عملك الحالي. هل أنت متأكد أنك تريد المتابعة؟',
			cancel: 'إلغاء',
			editAnyway: 'التعديل على أي حال',
			openCardError: 'حدثت مشكلة أثناء فتح هذه البطاقة. يرجى التواصل مع الدعم',
			cardClonedTitle: 'تم استنساخ البطاقة بنجاح',
			cardClonedText: 'تم استنساخ البطاقة في مساحة العمل المحددة.',
			deleteConfirmTitle: 'هل أنت متأكد؟',
			deleteConfirmText: 'هل تريد حذف هذه البطاقة؟',
			no: 'لا',
			yes: 'نعم',
			error: 'خطأ',
			warning: 'تحذير',
			noCategoriesFound: 'لم يتم العثور على فئات تصميم!',
			oopsExclaim: 'عذرًا!',
			oops: 'عذرًا',
			noWorkspaces: 'يبدو أنه ليس لديك أي مساحات عمل بعد.',
		},
	},
};
export default dashboard;
